import { motion } from "framer-motion";

const IMAGES = [
  { src: "/fleet/truck-trailer.jpg", alt: "AeroAcres branded truck and drone spray trailer rig serving South Florida agriculture", span: "md:col-span-2 md:row-span-2" },
  { src: "/fleet/operator-field.png", alt: "AeroAcres FAA-certified drone operator flying agricultural spray drone over Florida field" },
  { src: "/fleet/team-meeting.png", alt: "AeroAcres team meeting with farmer to review drone spraying plan in Miami-Dade" },
  { src: "/fleet/safety-briefing.png", alt: "AeroAcres pilots in safety briefing before drone spray operation in the Redland" },
  { src: "/fleet/truck-wide.jpg", alt: "AeroAcres mobile spray unit truck pulling drone trailer in South Florida" },
  { src: "/fleet/trailer-angle.jpg", alt: "AeroAcres drone spray support trailer — mobile water and chemical staging" },
  { src: "/fleet/trailer-rear.jpg", alt: "AeroAcres drone fleet trailer rear with branded livery" },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-xs font-semibold tracking-[0.2em] uppercase text-accent mb-4">In the field</div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-primary font-bold leading-tight">
              Real flights. Real fields. <span className="text-accent">Real AeroAcres.</span>
            </h2>
          </div>
          <p className="text-muted-foreground max-w-md">
            A snapshot of our work across Homestead avocado groves, Miami-Dade tomato fields and Florida City row crops.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 grid-flow-dense auto-rows-[180px] md:auto-rows-[220px] gap-4">
          {IMAGES.map((img, i) => (
            <motion.div
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.04 }}
              className={`relative overflow-hidden rounded-2xl group ${img.span || ""}`}
            >
              <img src={img.src} alt={img.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-[800ms] group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-5">
                <div className="text-white text-sm font-semibold">{img.alt}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
